document.querySelectorAll('video').forEach((video) => {
	// Set initial state based on whether the video is playing
	updateVideoState(video);

	// Listen for events to update state
	video.addEventListener('play', () => updateVideoState(video));
	video.addEventListener('pause', () => updateVideoState(video));
	video.addEventListener('ended', () => updateVideoState(video));
});

function updateVideoState(video) {
	if (video.paused || video.ended) {
		video.classList.add('paused');
		video.classList.remove('playing');
	} else {
		video.classList.add('playing');
		video.classList.remove('paused');
	}
}
